
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as g_wCPglAVKfxfkf8e408w4b_45cHmQ4Ak8bZKLimGuZXdwMeta } from "/codebuild/output/src1035372185/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue?macro=true";
import { default as indexRrQmvO6vGjaU0aWYJRNdDs3CyDyyrNoTzK0QYmazKwcMeta } from "/codebuild/output/src1035372185/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue?macro=true";
import { default as searchq_45YMcSNIW50fsv1Ijyr5RwqECL_45Pvyg8bdmwjdmd0_45EMeta } from "/codebuild/output/src1035372185/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue?macro=true";
import { default as index4xNmTohQONQCm3ggUZNXQrzdInzLVpMyPcBrvQqrwPMMeta } from "/codebuild/output/src1035372185/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue?macro=true";
import { default as _91id_93AH6JPEhdDsQEbLNceY0rmo8MymVStp9sMxGtTKoOgukMeta } from "/codebuild/output/src1035372185/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue?macro=true";
import { default as indexEUMzH4Dt74qrLlhoiCjlsTDHqvA2rsp38H_452ntg434gMeta } from "/codebuild/output/src1035372185/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue?macro=true";
import { default as _91id_930KvizLrWKzPblaQWYBPhcB7hrgkwAuOnojnzTgpt2rMMeta } from "/codebuild/output/src1035372185/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue?macro=true";
import { default as indexPlqSj3Z5Bfi5Nu6tUhAl_45mzmPdxX1rXRj4O_ZcnfP0YMeta } from "/codebuild/output/src1035372185/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue?macro=true";
import { default as _91id_93_45UlMtW7ynWDhpc_DQDwUuvRN9APsHcDmJq6Ja9coKQMMeta } from "/codebuild/output/src1035372185/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue?macro=true";
import { default as indexizgmtotbBZw35oXt97entOtlINw06zuKftbMG8ESerAMeta } from "/codebuild/output/src1035372185/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue?macro=true";
import { default as indexmVLXowp0_olyDjkC9enXzMj9HGtZxh_45aFAU7LpLxpm0Meta } from "/codebuild/output/src1035372185/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue?macro=true";
export default [
  {
    name: "g",
    path: "/g",
    component: () => import("/codebuild/output/src1035372185/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src1035372185/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/codebuild/output/src1035372185/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue")
  },
  {
    name: "v8",
    path: "/v8",
    component: () => import("/codebuild/output/src1035372185/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue")
  },
  {
    name: "video-id",
    path: "/video/:id()",
    component: () => import("/codebuild/output/src1035372185/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue")
  },
  {
    name: "terms",
    path: "/terms",
    meta: indexEUMzH4Dt74qrLlhoiCjlsTDHqvA2rsp38H_452ntg434gMeta || {},
    component: () => import("/codebuild/output/src1035372185/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue")
  },
  {
    name: "article-id",
    path: "/article/:id()",
    component: () => import("/codebuild/output/src1035372185/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue")
  },
  {
    name: "contact",
    path: "/contact",
    meta: indexPlqSj3Z5Bfi5Nu6tUhAl_45mzmPdxX1rXRj4O_ZcnfP0YMeta || {},
    component: () => import("/codebuild/output/src1035372185/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue")
  },
  {
    name: "v8-article-id",
    path: "/v8/article/:id()",
    component: () => import("/codebuild/output/src1035372185/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    meta: indexizgmtotbBZw35oXt97entOtlINw06zuKftbMG8ESerAMeta || {},
    component: () => import("/codebuild/output/src1035372185/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue")
  },
  {
    name: "privacy-policy-relationships",
    path: "/privacy-policy/relationships",
    meta: indexmVLXowp0_olyDjkC9enXzMj9HGtZxh_45aFAU7LpLxpm0Meta || {},
    component: () => import("/codebuild/output/src1035372185/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue")
  }
]